// extracted by mini-css-extract-plugin
export default {"p":"_14fa953c25 c5695fa180 _15a554a5d3","clr":"d0b5ce4059","dls":"b7ad080876"};